import { Directive, Input, numberAttribute } from '@angular/core'

import {
  BranchDetailBaseEventParams,
  TableData,
} from './branch-detail-base.component'

export function offsetTransform(value: number | null): number {
  return numberAttribute(value, 1)
}

@Directive()
export abstract class BranchDetailBaseAbstract {
  // get from routing path
  @Input() public id!: string
  // get from routing query. needs transform for default value
  @Input({ transform: offsetTransform })
  public offset!: number

  public isLoading = true
  public total: number = 0

  public typeToken!: { index: number; item: string; currentRow: TableData }

  protected constructor() {}

  public onBaseUpdate({
    isLoading,
    total,
    offset,
  }: BranchDetailBaseEventParams): void {
    this.isLoading = isLoading
    this.total = total
    this.offset = offset
  }
}
